module.exports = __webpack_public_path__ + "static/media/icon_stickers.947c6acc.png";